/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'
/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION MEDIA COMMENTS: STYLES --------------- ++++++++++ */
export default theme => ({
  preview: {
    '& .previewconfig': {
      maxWidth: '500px',
      '&.mobile': { 
        maxWidth: pxToEm(250),
        '& .emojipreview': {
          '& .emojicontainer': {
            overflowX: 'scroll',
            maxWidth: pxToEm(250),
            '&::-webkit-scrollbar': {
                height: pxToEm(6)
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'rgba(0, 0, 0, 0.15)',
                borderRadius: pxToEm(4)
            },
          }
        }
      },
      '& .content': {
        height: 'auto',
        '& .container': {
          maxWidth: pxToEm(360),
        },
        '& h3': {
          fontFamily: '"Source Serif Pro", Georgia, serif',
          fontSize: pxToEm(20)
        },
      },
    },
  
  }
});
